import { getPriceIncludingVAT } from './getPriceIncludingVAT';
import { getProductPriceExcludingVAT } from './getProductPriceExcludingVAT';

export default {
  getPriceIncludingVAT,
  getProductPriceExcludingVAT,
};
